// ============================================================================
// modules/auth/api/auth.api.ts
// Capa de datos de autenticación. Migrado de .js a .ts (misma lógica y contrato).
// Login cifrado AES; token en el CUERPO de la petición (contrato de este backend).
// ============================================================================
import { desencriptar } from "../../../shared/utils/funciones";
import { httpClient } from "../../../shared/api/httpClient";
import type { LoginResult, VerificarResult, NavegarOtraAppResult } from "../types/auth.types";

export const authLogin = async (dataPOST: Record<string, unknown>): Promise<LoginResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/Login", dataPOST);
        // res.status 201
        if (res.status === 201) {
            // Desencriptar el res
            const resDesencriptado = desencriptar(res.data.body);

            return {
                status: resDesencriptado.status,
                usuario: resDesencriptado,
                message: resDesencriptado.message,
                resEncriptado: res.data.body,
            };
        }

        if (res.status === 200) {
            return {
                status: 0,
                usuario: null,
                message: res.data.message,
                resEncriptado: null,
            };
        }
    } catch (error: any) {
        return {
            status: -1,
            usuario: null,
            message: error.message,
            resEncriptado: null,
        };
    }
};

export const verificarUsuario = async (dataPOST: Record<string, unknown>): Promise<VerificarResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/VerificarUseMod", dataPOST);

        if (res.data.status === 1) {
            return {
                status: res.data.status,
                autenticado: res.data.valor,
                message: res.data.message,
            };
        }
    } catch (error: any) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                autenticado: false,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            autenticado: false,
            message: "Error en el servidor",
        };
    }
};

export const navegarOtraApp = async (dataPOST: Record<string, unknown>): Promise<NavegarOtraAppResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/OtrosSistemas", dataPOST);

        if (res.data.status === 1) {
            return {
                status: res.data.status,
                apps: res.data.rutas,
                message: res.data.message,
            };
        }
    } catch (error: any) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                apps: [],
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            apps: [],
            message: "Error en el servidor",
        };
    }
};
